import { Input, theme, Switch } from 'components';
import styled from 'styled-components';
import { buildCssProps } from 'utils';

export const StyledTemplateLayout = styled.div<{ $blur?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 2fr;
  box-shadow: rgba(0, 0, 0, 0.1) inset -4px 0px 20px;
  min-width: 903px;
  ${({ $blur }) =>
    buildCssProps([
      ['filter', $blur && `blur(${theme.pageBlurRadius})`],
      ['pointer-events', $blur && 'none'],
    ])}
`;

export const StyledInput = styled(Input)`
  min-width: 12em;
`;

export const ListContainer = styled.div`
  border-right: 1px solid ${theme.gray4};
  padding: 20px 0 0;
  height: calc(100vh - 175px);
`;

export const EditorContainer = styled.div`
  padding: 20px;
  padding-right: 24px;
`;

export const SearchBarContainer = styled.div`
  margin-bottom: 16px;
  padding: 0 10px;
`;

export const FilterContainer = styled.div`
  padding: 0 24px 16px;
  border-bottom: 1px solid ${theme.gray4};

  > button {
    margin-right: 8px;
    margin-bottom: 8px;
  }
`;

export const TemplateSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* flex-flow: row nowrap; */
  margin-bottom: 16px;
`;

export const TemplateSettingsActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TemplateSettingsActionsRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  /* Offset by the label height */
  margin-top: 14px;
  align-items: flex-end;
  width: 100%;
`;

export const SubjectContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const AlertContainer = styled.div`
  margin-bottom: 16px;
`;

export const DefaultContainer = styled.div<{ emptyAbove?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ emptyAbove }) => (emptyAbove ? 'margin-top: 32px;' : '')}
`;

export const InputGroup = styled.div<{
  stretch?: boolean;
  marginBottom?: boolean;
}>`
  &:not(:last-child) {
    margin-right: 16px;
  }
  ${({ marginBottom }) => (marginBottom ? 'margin-bottom: 12px;' : '')}
  ${({ stretch }) => (stretch ? 'flex: 1;' : '')}
`;

export const LastEditedLabel = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: ${theme.gray7};
`;

export const StyledValidationLabel = styled.div`
  font-weight: 600;
  color: ${theme.getColor('danger')};
`;

export const StyledSwitch = styled(Switch)`
  margin-bottom: 4px;
`;
